import {
  type AnchorHTMLAttributes,
  type DetailedHTMLProps,
  type FC,
  type PropsWithChildren,
  useMemo,
} from 'react';

type ExternalRedirectProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  /**
   * isMatureContent - if true, embeds an `a` query param to add a warning message to the /link page.
   */
  hasMatureContent?: boolean;
};

/**
 * Helper function version to generate an external link.
 * @return URL string of a link to our /link page i.e. "/link?r=https://www.furality.org&boothId=505&a=true"
 */
export const getExternalRedirectLink = (params: ExternalRedirectProps): string => {
  const { hasMatureContent, href } = params;

  const searchParams = new URLSearchParams({
    ...(href && { r: href }),
    ...(hasMatureContent && { a: hasMatureContent.toString() }),
  });

  return `/link?${searchParams.toString()}`;
};

const ExternalRedirectLink: FC<PropsWithChildren<ExternalRedirectProps>> = ({
  href,
  hasMatureContent,
  children,
  ...props
}) => {
  const redirectUrl = useMemo(() => {
    return getExternalRedirectLink({ hasMatureContent, href });
  }, [hasMatureContent, href]);

  return (
    <a target="_blank" rel="noreferrer" href={redirectUrl} {...props}>
      {children}
    </a>
  );
};

export default ExternalRedirectLink;
